import TextField from '@guestyci/foundation/TextField';
import Layout from 'app/shareable/layouts/Layout';
import useCustomTextFieldStyles from 'app/shareable/theme/useCustomTextFieldStyles';

export default function VerifiedFailedPage() {
  const classes = useCustomTextFieldStyles();

  return (
    <Layout captureText="One Tool. Better Way To Manage.">
      <div>
        <TextField className={classes.h1}>Oh No! </TextField>
        <div className="mt-2">
          <TextField className={classes.h3}>
            Unfortunately, we could not verify your email.
          </TextField>
          <TextField className={classes.h3}>
            Please send us an email at{' '}
            <a className={classes.link} href="mailto:hello@guestyforhosts.com">
              hello@guestyforhosts.com
            </a>
            .
          </TextField>
        </div>
      </div>
    </Layout>
  );
}
